const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "Android";
  } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
    return "iOS";
  }
  return "Other";
};

const changeMobileMenuFooter = () => {
  const mobileOS = getMobileOS();
  if (mobileOS === "iOS") {
    const mobileMenuFooter = document.querySelector("[data-mobile--menu-footer]");
    if (mobileMenuFooter) {
      mobileMenuFooter.classList.add("ios");
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  changeMobileMenuFooter();
});
